import React, { Component } from 'react';
import { connect } from 'react-redux';
import { config } from '../../env_config/react-config';

const imageBaseUrl = config.medias;

/**
 * Offline Component
 * @function Offline
 * Displays the Offline page
 * @return {div}
 */
const Offline = (props) => (
    <div className="page404">
        <img className="img-fluid" alt={props.commonDetails.offline} src={imageBaseUrl + '/themes/custom/dlc/images/offline.gif'} />
    </div>
)

const mapStateToProps = state => ({
    commonDetails: state.commonReducer.commonDetails
});

export default connect(mapStateToProps)(Offline);
